import { createSelector } from "reselect";

const overviewDetails = (state) => state.dashboard.overviewDetails;
const globalAreaType = (state) => state.dashboard.areaType;
const totalAsha = (state)=> state.dashboard.totalAsha;
const paginationData = (state) => state.dashboard.paginationData;
const globalDistrictId = (state) => state.dashboard.districtId;
const getSelectedDistId = (state) => state.dashboard.distId;
const getTalukaId = (state) => state.dashboard.talukaId;
const getPhcId = (state) => state.dashboard.phcId;
const totalAshaTableList = (state) => state.dashboard.totalAshaTableList;
const sendPhc = (state) => state.dashboard.sendPhc;
const sendTaluka = (state) => state.dashboard.sendTaluka;
const notificationList = (state) => state.dashboard.notificationList;
const isNotifyLoading = (state) => state.dashboard.isLoading;
const AshaByRegion = (state) => state.dashboard.AshaByRegion;
export const getOverviewDetails = createSelector(
  [overviewDetails],
  (data) => data
);
export const getTotalAsha = createSelector(
  [totalAsha],
  (data)=>(data)
);
export const getAshaPaginationData = createSelector([paginationData], (data) => data);
export const getTaluka = createSelector([getTalukaId], (data) => data);
export const getPhc = createSelector([getPhcId], (data) => data);
export const getGlobalDistrictId = createSelector(
  [globalDistrictId],
  (data) => data
);
export const getSendPhc = createSelector([sendPhc], (data) => data);
export const getSendTaluka = createSelector([sendTaluka], (data) => data);
export const getSelectedDistrictId = createSelector(
  [getSelectedDistId],
  (data) => data
);
export const getGlobalAreaType = createSelector(
  [globalAreaType],
  (data) => data
);
export const getTotalAshaTableList = createSelector(
  [totalAshaTableList],
  (data) => data
);

export const getNotifications = createSelector(
  [notificationList],
  (data) => data
);
export const getIsNotLoading = createSelector(
  [isNotifyLoading],
  (data) => data
);
export const getAshaByRegion = createSelector([AshaByRegion], (data) => data);
